function selectOption(radioOption) {
  // removing active status from all siblings
  const allRadioOptionsFromGroup =
    radioOption.parentElement.parentElement.parentElement.children;
  for (element of allRadioOptionsFromGroup) {
    element.classList.remove("active");
  }
  // changing style of active radio button
  radioOption.parentElement.parentElement.classList.add("active");
}

function openList(button) {
  button.querySelector(".chevron").classList.toggle("rotate-up");
  button.parentElement.classList.toggle("open");
}

function chooseOption(choosenItem) {
  const placeholder =
    choosenItem.parentElement.parentElement.querySelector(".placeholder");
  const choosenValue = choosenItem.getAttribute("data-value");
  const list = choosenItem.parentElement;
  const input = document.getElementById(list.id + "-value");

  placeholder.innerHTML = choosenValue;
  placeholder.classList.add("selected");
  list.parentElement.classList.toggle("open");
  input.value = choosenValue;
}
